<template>

	<section class="page_404">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 ">
					<div class="col-sm-10 col-sm-offset-1  text-center">
						<div class="four_zero_four_bg">

						</div>

						<div class="content_box_404" v-if="maintenance">
							<p style="margin-top: 40px"><strong><span v-html="$t('UnderMaintenance')"></span></strong></p>
						</div>

						<div class="content_box_404" v-else-if="configError">
							<p style="margin-top: 40px"><strong><span v-html="$t('ConfigurationError')"></span></strong></p>
						</div>

						<div class="content_box_404" v-else-if="expired">
							<p style="margin-top: 40px"><span v-html="$t('Expired')"></span></p>
						</div>

						<div class="content_box_404" v-else-if="redeemed">
							<p style="margin-top: 40px"><span v-html="$t('Redeemed')"></span></p>
						</div>

						<div class="content_box_404" v-else-if="invalid">
							<p style="margin-top: 40px"><span v-html="$t('Invalid')"></span></p>
						</div>

						<div class="content_box_404" v-else-if="root">
							<p style="margin-top: 40px"><span v-html="$t('Root')"></span></p>
						</div>

						<div class="content_box_404" v-else>
							<p v-html="$t('ErrorMessage')" style="margin-top: 40px">
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>


</template>

<script>
    export default {
        mounted() {

            if(this.$route.path === '/')
            	this.root = true;

            let maintenance = this.$route.query.maintenance;
            if (maintenance) {
                this.maintenance = true;
            }

            let configError = this.$route.query.configError;
            if (configError) {
                this.configError = true;
            }

            let expired = this.$route.query.expired;
            if (expired) {
                this.expired = true;
            }

            let redeemed = this.$route.query.redeemed;
            if (redeemed) {
                this.redeemed = true;
            }

            let invalid = this.$route.query.invalid;
            if (invalid) {
                this.invalid = true;
            }

        },
        data: function () {
            return {
                configError: false,
				expired: false,
				redeemed: false,
				invalid: false,
				root: false,
				maintenance: false
			}
        }
    }


</script>

<style scoped>


	.page_404 {
		padding: 40px 0;
		background: #fff;
		font-family: "Nunito Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;;
	}

	.page_404 img {
		width: 100%;
	}

	.four_zero_four_bg {

		background-image: url('/img/notfound.gif');
		height: 400px;
		background-position: center;
	}


	.four_zero_four_bg h1 {
		font-size: 80px;
	}

	.four_zero_four_bg h3 {
		font-size: 80px;
	}

	.content_box_404 {
		margin-top: -50px;
	}

</style>